/* Affekt yeni tasarım — etkileşimler */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Menü çekmecesi ---------- */
  function openDrawer(open) {
    var d = $('#ak-drawer'); if (!d) return;
    d.classList.toggle('is-open', open);
    d.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.documentElement.classList.toggle('ak-lock', open);
    $$('[data-ak-menu]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) { var c = $('[data-ak-close]', d); if (c) c.focus(); }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-ak-menu]')) { e.preventDefault(); openDrawer(true); }
    if (e.target.closest('[data-ak-close]')) { e.preventDefault(); openDrawer(false); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openDrawer(false); });

  /* ---------- Sepet ---------- */
  function setCount(n) {
    $$('[data-ak-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
    $$('[data-ak-cart-label]').forEach(function (el) { el.setAttribute('aria-label', 'Sepet, ' + n + ' ürün'); });
    $$('[data-ak-cart-text]').forEach(function (el) { el.textContent = 'Sepetim (' + n + ')'; });
  }
  function markAdded(id) {
    $$('[data-ak-add="' + id + '"]').forEach(function (b) {
      b.classList.add('is-added'); b.textContent = 'Eklendi ✓';
      b.setAttribute('aria-label', (b.getAttribute('data-title') || 'Ürün') + ' sepete eklendi. Sepete gitmek için dokunun.');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ak-add]'); if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-added')) { window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart'; return; }
    var id = b.getAttribute('data-ak-add');
    b.disabled = true; var old = b.textContent; b.textContent = 'Ekleniyor…';
    var item = { id: Number(id), quantity: 1 }, when = b.getAttribute('data-when');
    if (when) item.properties = { _tarih: when }; /* workshop oturum tarihi siparişe gizli not olarak eklenir */
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (cart) { b.disabled = false; markAdded(id); setCount(cart.item_count); })
      .catch(function () { b.disabled = false; b.textContent = old; alertLive('Ürün sepete eklenemedi. Lütfen tekrar deneyin.'); });
  });
  function alertLive(msg) {
    var r = $('#ak-live'); if (!r) { r = document.createElement('div'); r.id = 'ak-live'; r.className = 'ak-sr'; r.setAttribute('role', 'status'); document.body.appendChild(r); }
    r.textContent = msg;
  }

  /* ---------- Konu filtreleri (koleksiyon) ---------- */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-ak-filter]'); if (!c) return;
    var wrap = c.closest('[data-ak-filter-scope]'); if (!wrap) return;
    var key = c.getAttribute('data-ak-filter');
    $$('[data-ak-filter]', wrap).forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
    var n = 0;
    $$('[data-cats]', wrap).forEach(function (it) {
      var ok = key === 'hepsi' || (' ' + it.getAttribute('data-cats') + ' ').indexOf(' ' + key + ' ') >= 0;
      it.hidden = !ok; if (ok) n++;
    });
    var cnt = $('[data-ak-count]', wrap);
    if (cnt) cnt.textContent = n ? n + ' ' + cnt.getAttribute('data-unit') : 'Bu konuda şu an eğitim bulunmuyor. Diğer konulara göz atabilirsiniz.';
  });

  /* ---------- Aç/kapa notlar (madalya, onaylı bilgi) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ak-toggle]'); if (!t) return;
    var group = t.getAttribute('data-ak-group');
    var target = document.getElementById(t.getAttribute('data-ak-toggle'));
    var open = t.getAttribute('aria-expanded') !== 'true';
    if (group) $$('[data-ak-group="' + group + '"]').forEach(function (o) {
      if (o !== t) { o.setAttribute('aria-expanded', 'false'); var x = document.getElementById(o.getAttribute('data-ak-toggle')); if (x) x.hidden = true; }
    });
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (target) target.hidden = !open;
  });

  /* ---------- Ürün sayfasında alt satın alma çubuğu ---------- */
  var main = $('[data-ak-buy-main]'), sticky = $('[data-ak-sticky-buy]');
  if (main && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { sticky.classList.toggle('is-show', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(main);
  }

  /* ---------- Yorumlar sayfası (Judge.me) ----------
     Kasım 2026: mağaza yorumları (Affekt Wellness) ile etkinlik yorumları (workshop + video eğitim) ayrıdır.
     Bir eğitime gelen yorum, o eğitimi sunan uzmana da gelmiş sayılır: "e:isil" gibi uzman süzgeçleri uzmanın eğitimlerine gelen yorumları gösterir.
     Her süzgeç kendi Judge.me kaynağından yüklenir: tümü → all-reviews, etkinlik/uzman → product-reviews, mağaza → shop-reviews. */
  var rv = $('[data-ak-reviews]');
  if (rv) initReviews(rv);
  function initReviews(root) {
    var list = $('[data-ak-rlist]', root), moreBtn = $('[data-ak-rmore]', root), line = $('[data-ak-rline]', root);
    var shop = root.getAttribute('data-shop');
    var cnt = { all: +root.getAttribute('data-c-all') || 0, ws: +root.getAttribute('data-c-ws') || 0, shop: +root.getAttribute('data-c-shop') || 0 };
    $$('[data-ak-rfilter^="e:"]', root).forEach(function (b) { cnt[b.getAttribute('data-ak-rfilter')] = +b.getAttribute('data-c') || 0; });
    var MP = window.AKRV || { key: function () { return ''; }, BY: {}, ready: Promise.resolve() };
    var filter = 'all', shown = 20, MAXP = 40;
    var SRC = { 'all-reviews': { data: [], page: 0, done: false, loading: null, seen: {} }, 'product-reviews': { data: [], page: 0, done: false, loading: null, seen: {} }, 'shop-reviews': { data: [], page: 0, done: false, loading: null, seen: {} } };
    var srcOf = function (f) { return f === 'ws' || f.indexOf('e:') === 0 ? 'product-reviews' : f === 'shop' ? 'shop-reviews' : 'all-reviews'; };
    function kind(r) {
      var p = r.p || '';
      if (r.sr || !p || /wellnes/i.test(p) || r.u === '/') return 'shop';
      if (/^online terapi/i.test(p) || /\/products\/terapi-/.test(r.u || '')) return 'uz';
      return 'ws';
    }
    function add(src, r) { r.k = kind(r); var id = r.n + r.d + r.b + r.p; if (src.seen[id]) return; src.seen[id] = 1; src.data.push(r); }
    try {
      JSON.parse($('#ak-reviews-data').textContent).forEach(function (r) {
        add(SRC['all-reviews'], { n: r.reviewer_name || 'Anonim', v: !!r.verified_buyer, s: r.rating || 5, d: (r.created_at || '').slice(0, 10), c: r.location_country_code || '', t: r.title || '', b: r.body || '', p: r.product_title || '', u: r.product_url || '', sr: !!r.is_shop_review });
      });
      SRC['all-reviews'].page = 1;
    } catch (e) {}
    var flag = function (cc) { return cc.replace(/./g, function (ch) { return String.fromCodePoint(127397 + ch.charCodeAt(0)); }); };
    var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var fmt = function (d) { return d ? d.slice(8, 10) + '.' + d.slice(5, 7) + '.' + d.slice(0, 4) : ''; };
    var uzOf = function (r) { if (!r.e && r.k !== 'shop') r.e = MP.key(r); return r.e || ''; };
    var match = function (r) {
      if (filter.indexOf('e:') === 0) return r.k !== 'shop' && uzOf(r) === filter.slice(2);
      return filter === 'all' || (filter === 'text' && (r.b || r.t)) || (filter === 'ver' && r.v) || r.k === filter;
    };
    var rows = function () { return SRC[srcOf(filter)].data.filter(match); };
    function fetchPage(name) {
      var src = SRC[name];
      if (src.done) return Promise.resolve();
      if (src.loading) return src.loading;
      var u = 'https://api.judge.me/reviews/all_reviews_js_based?' + new URLSearchParams({ url: location.hostname, shop_domain: shop, platform: 'shopify', page: src.page + 1, per_page: 25, review_type: name });
      src.loading = fetch(u).then(function (r) { return r.json(); }).then(function (j) {
        var box = document.createElement('div'); box.innerHTML = j.html || '';
        var got = $$('.jdgm-rev', box).map(function (el) {
          var q = function (s) { return el.querySelector(s); };
          var tx = function (s) { var x = q(s); return x ? x.textContent.replace(/\s+/g, ' ').trim() : ''; };
          var at = function (s, a) { var x = q(s); return x ? (x.getAttribute(a) || '') : ''; };
          var body = $$('.jdgm-rev__body p', el).map(function (p) { return p.textContent.trim(); }).filter(Boolean).join('\n') || tx('.jdgm-rev__body');
          return { n: tx('.jdgm-rev__author') || 'Anonim', v: el.getAttribute('data-verified-buyer') === 'true', s: +at('.jdgm-rev__rating', 'data-score') || 5,
            d: at('.jdgm-rev__timestamp', 'data-content').slice(0, 10), c: at('.jdgm-rev__location', 'data-country-code'),
            t: tx('.jdgm-rev__title'), b: body, p: tx('.jdgm-rev__prod-title') || tx('.jdgm-rev__prod-link'), u: at('a.jdgm-rev__prod-link', 'href') };
        });
        src.page++; src.loading = null;
        got.forEach(function (r) { add(src, r); });
        if (!got.length || src.page >= MAXP) src.done = true;
      }).catch(function () { src.loading = null; src.done = true; });
      return src.loading;
    }
    function ensure() {
      /* Seçili süzgeçte istenen sayıda yorum olana kadar (veya kaynak bitene kadar) sayfa çeker */
      var name = srcOf(filter), src = SRC[name];
      if (rows().length >= shown || src.done) return Promise.resolve();
      return fetchPage(name).then(ensure);
    }
    var KL = { ws: 'Etkinlik', shop: 'Mağaza', uz: 'Online terapi' };
    function render() {
      var name = srcOf(filter), src = SRC[name];
      var all = rows(), view = all.slice(0, shown), i = 0;
      if (!all.length) {
        list.innerHTML = '<div class="ak-sub" style="padding:18px;text-align:center;font-size:14px">' +
          (filter.indexOf('e:') === 0 ? 'Bu uzmanın eğitimlerine henüz yorum bulunmuyor.' : 'Bu süzgeçte henüz yorum bulunmuyor.') + '</div>';
        line.textContent = ''; moreBtn.hidden = true; return;
      }
      list.innerHTML = view.map(function (r) {
        i++;
        var stars = '★★★★★'.slice(0, r.s) + '☆☆☆☆☆'.slice(0, 5 - r.s);
        var what = r.k === 'shop' ? 'Affekt Wellness mağazası' : (r.p || '');
        var ex = r.k !== 'shop' ? MP.BY[uzOf(r)] : null;
        return '<figure class="ak-card ak-rev">' +
          '<div class="ak-rev__head"><div class="ak-rev__who"><b>' + esc(r.n) + '</b>' +
          (r.c ? '<span role="img" aria-label="' + esc(r.c) + '">' + flag(r.c) + '</span>' : '') +
          (r.v ? '<span class="ak-verified">✓ Onaylı</span><button type="button" class="ak-info-btn" data-ak-toggle="akv' + i + '" aria-expanded="false" aria-label="Onaylı ne demek?">ⓘ</button>' : '') +
          '</div><span class="ak-stars" aria-label="5 üzerinden ' + r.s + ' yıldız">' + stars + '</span></div>' +
          (r.v ? '<div class="ak-note" id="akv' + i + '" role="note" hidden style="background:#F3ECE2">Bu yorum, internet sitemizden alışveriş yapan bir katılımcıdan toplanmıştır.</div>' : '') +
          (r.t ? '<div style="font-weight:800">' + esc(r.t) + '</div>' : '') +
          (r.b ? '<blockquote>' + esc(r.b) + '</blockquote>' : '<div class="ak-sub" style="font-size:14px">Yalnızca puan verildi.</div>') +
          '<div class="ak-rev__meta"><span style="display:flex;align-items:center;gap:8px;flex-wrap:wrap;min-width:0"><span class="ak-rkind ak-rkind--' + r.k + '">' + KL[r.k] + '</span>' + (ex ? '<span class="ak-rkind ak-rkind--uzm" style="--c:' + ex.color + '">' + esc(ex.name) + '</span>' : '') + esc(what) + '</span><span>' + fmt(r.d) + '</span></div></figure>';
      }).join('');
      var total = cnt[filter] || all.length;
      line.textContent = Math.max(total, all.length) + ' yorumdan ' + view.length + ' tanesi gösteriliyor · en yeniler önce';
      moreBtn.hidden = src.done && view.length >= all.length;
      moreBtn.textContent = 'Daha fazla yorum gösterin';
    }
    function go() { moreBtn.textContent = 'Yükleniyor…'; return ensure().then(render); }
    moreBtn.addEventListener('click', function () { shown += 20; go(); });
    $$('[data-ak-rfilter]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        filter = b.getAttribute('data-ak-rfilter'); shown = 20;
        $$('[data-ak-rfilter]', root).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        list.innerHTML = '<div class="ak-sub" style="padding:18px;text-align:center;font-size:14px">Yorumlar yükleniyor…</div>';
        go();
      });
    });
    /* uzman eşlemesi güncel ürünlerle tamamlanınca yeniden çiz */
    go(); MP.ready.then(function () { Object.keys(SRC).forEach(function (n) { SRC[n].data.forEach(function (r) { r.e = ''; }); }); render(); });
  }
})();
